export default __webpack_public_path__ + "static/media/banner-bg-mes-mulheres.1fcc92bc.png";